import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'

import { Flex, Select, theme } from 'pcln-design-system'

// React components *should not* be defined in the render method
// This can severely affect performance
const AgeFlex = styled(Flex)`
  svg {
    color: ${props => props.theme.colors.blue};
  }
`
AgeFlex.displayName = 'AgeFlex'
AgeFlex.defaultProps = {
  theme
}

class ChildAgeSelect extends React.Component {
  static propTypes = {
    childIndex: PropTypes.number.isRequired,
    childAge: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    updateChildAge: PropTypes.func
  }

  shouldComponentUpdate (nextProps) {
    return nextProps.childAge !== this.props.childAge
  }

  handleChildAgeChange = event => {
    if (this.props.updateChildAge) {
      this.props.updateChildAge(this.props.childIndex, event.target.value)
    }
  }

  render () {
    const { childAge, childIndex } = this.props
    const ageDefaultValue = childAge || `Add Child ${childIndex}`
    const selectStyle = {
      borderTopStyle: 'none',
      borderRightStyle: 'none',
      borderBottomStyle: 'none',
      borderLeftStyle: 'none',
      fontWeight: 700,
      fontSize: 16,
      width: 200,
      cursor: 'pointer'
    }

    return (
      <AgeFlex justifyContent='center' my={1}>
        <Select
          name='childAgeSelect'
          defaultValue={ageDefaultValue}
          onChange={this.handleChildAgeChange}
          style={selectStyle}
        >
          <option value={-1}>{`Add Child ${childIndex}`}</option>
          <option value={0}>0-1 Infant in lap</option>
          <option value={1}>0-1 Infant in seat</option>
          <option value={2}>2 yrs</option>
          <option value={3}>3 yrs</option>
          <option value={4}>4 yrs</option>
          <option value={5}>5 yrs</option>
          <option value={6}>6 yrs</option>
          <option value={7}>7 yrs</option>
          <option value={8}>8 yrs</option>
          <option value={9}>9 yrs</option>
          <option value={10}>10 yrs</option>
          <option value={11}>11 yrs</option>
          <option value={12}>12 yrs</option>
          <option value={13}>13 yrs</option>
          <option value={14}>14 yrs</option>
          <option value={15}>15 yrs</option>
          <option value={16}>16 yrs</option>
          <option value={17}>17 yrs</option>
        </Select>
      </AgeFlex>
    )
  }
}

ChildAgeSelect.displayName = 'ChildAgeSelect'

export default ChildAgeSelect
